import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useVendor from 'src/hooks/useVendor';

const DashboardRedirect: FC<React.PropsWithChildren<unknown>> = () => {
  const navigate = useNavigate();
  const { vendor } = useVendor();

  useEffect(() => {
    navigate(`/${vendor.number || 0}`, { replace: true });
  }, [vendor.number, navigate]);

  return <div></div>;
};

export default DashboardRedirect;
